export default __webpack_public_path__ + "static/media/buyContactViaChat.43ca4aaa.png";